import { orderTypeConstants } from "constants/order";
import { Label } from "layout/typography/Label";
import { orderTypes } from "pages/CreateOrder/components/Header/constants";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useListModelsQuery } from "store/queries/chat";

type OrderCommunicationDetailsFields =
  | "messageSender"
  | "emailSender"
  | "emailTemplateAttempt1"
  | "attempt1"
  | "emailTemplateAttempt2"
  | "attempt2"
  | "emailTemplateAttempt3"
  | "attempt3"
  | "emailTemplateAttemptBundle1"
  | "attemptBundle1"
  | "emailTemplateAttemptBundle2"
  | "attemptBundle2"
  | "emailTemplateAttemptBundle3"
  | "attemptBundle3"
  | "accountLogoUrl"
  | "emailTemplateAttemptED1"
  | "attemptED1"
  | "emailTemplateAttemptED2"
  | "attemptED2"
  | "emailTemplateAttemptED3"
  | "attemptED3"
  | "emailTemplateAttemptBariatrics1"
  | "attemptBariatrics1"
  | "emailTemplateAttemptBariatrics2"
  | "attemptBariatrics2"
  | "emailTemplateAttemptBariatrics3"
  | "attemptBariatrics3"
  | "emailTemplateAttemptGFE1"
  | "attemptGFE1"
  | "emailTemplateAttemptGFE2"
  | "attemptGFE2"
  | "emailTemplateAttemptGFE3"
  | "attemptGFE3"
  | "openAiChatModelId";

export function OrderCommunicationDetails() {
  const [expanded, setExpanded] = useState(false);
  const { control, trigger, watch } = useFormContext<any>();
  const orderType = watch("orderType");
  const { data: chatModels, isLoading: isLoadingModels } = useListModelsQuery();

  async function handleOnBlurField({
    onBlur,
    field,
  }: {
    onBlur: () => void;
    field: OrderCommunicationDetailsFields;
  }) {
    trigger(field);
    onBlur();
  }

  return (
    <div className="block bg-white border-round-xl p-4 border-1 border-gray-300">
      <button
        type="button"
        className="flex align-items-center justify-content-between w-full border-none bg-transparent p-0 cursor-pointer text-left"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
      >
        <span className="text-black font-bold text-lg m-0">
          Order Communication Details
        </span>
        <i
          className={`pi pi-chevron-down text-gray-600 transition-duration-200 transition-all ${
            expanded ? "rotate-180" : ""
          }`}
          style={{ fontSize: "0.75rem" }}
          aria-hidden
        />
      </button>
      {expanded && (
        <div className="flex flex-column gap-4 mt-4">
          <div className="formgrid grid border-bottom-1 border-gray-200">
            <div className="field md:col-4 col-12">
              <Label htmlFor="messageSender">Message Sender</Label>
              <Controller
                name="messageSender"
                control={control}
                render={({ field: { onChange, onBlur, value } }) => (
                  <InputText
                    className="w-full"
                    id="messageSender"
                    autoComplete="off"
                    value={value || ""}
                    placeholder="Enter message sender here"
                    aria-labelledby="messageSender"
                    onBlur={() => {
                      handleOnBlurField({ onBlur, field: "messageSender" });
                    }}
                    onChange={onChange}
                  />
                )}
              />
            </div>
            <div className="field md:col-4 col-12">
              <Label htmlFor="emailSender">Email sender</Label>
              <Controller
                name="emailSender"
                control={control}
                render={({ field: { onChange, onBlur, value } }) => (
                  <InputText
                    className="w-full"
                    id="emailSender"
                    autoComplete="off"
                    value={value || ""}
                    placeholder="Enter email sender here"
                    aria-labelledby="emailSender"
                    onBlur={() => {
                      handleOnBlurField({ onBlur, field: "emailSender" });
                    }}
                    onChange={onChange}
                  />
                )}
              />
            </div>
            <div className="field md:col-4 col-12">
              <Label htmlFor="orderType">Order Type</Label>
              <Controller
                name="orderType"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <Dropdown
                    id="orderType"
                    data-testid="orderType"
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                    }}
                    options={Object.values(orderTypes)}
                    optionLabel="name"
                    placeholder="Select"
                    className="w-full"
                  />
                )}
              />
            </div>
          </div>
          <div className="flex flex-column border-bottom-1 border-gray-200 pb-2">
            <span className="font-medium text-md">Mobile Alert Messages</span>
            {orderType === orderTypeConstants.PATIENT_RESPONSIBILITY && (
              <>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attempt1">Attempt 1 Message</Label>
                  <Controller
                    name="attempt1"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attempt1"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attempt1"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({ onBlur, field: "attempt1" });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attempt2">Attempt 2 Message</Label>
                  <Controller
                    name="attempt2"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attempt2"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attempt2"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({ onBlur, field: "attempt2" });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attempt3">Attempt 3 Message</Label>
                  <Controller
                    name="attempt3"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attempt3"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attempt3"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({ onBlur, field: "attempt3" });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
              </>
            )}
            {orderType === orderTypeConstants.ED && (
              <>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attemptED1">Attempt 1 Message</Label>
                  <Controller
                    name="attemptED1"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attemptED1"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attemptED1"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({ onBlur, field: "attemptED1" });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attemptED2">Attempt 2 Message</Label>
                  <Controller
                    name="attemptED2"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attemptED2"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attemptED2"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({ onBlur, field: "attemptED2" });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attemptED3">Attempt 3 Message</Label>
                  <Controller
                    name="attemptED3"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attemptED3"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attemptED3"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({ onBlur, field: "attemptED3" });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
              </>
            )}

            {orderType === orderTypeConstants.BUNDLED && (
              <>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attemptBundle1">Attempt 1 Message</Label>
                  <Controller
                    name="attemptBundle1"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attemptBundle1"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attemptBundle1"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "attemptBundle1",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attemptBundle2">Attempt 2 Message</Label>
                  <Controller
                    name="attemptBundle2"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attemptBundle2"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attemptBundle2"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "attemptBundle2",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attemptBundle3">Attempt 3 Message</Label>
                  <Controller
                    name="attemptBundle3"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attemptBundle3"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attemptBundle3"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "attemptBundle3",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
              </>
            )}

            {orderType === orderTypeConstants.BARIATRICS && (
              <>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attemptBariatrics1">Attempt 1 Message</Label>
                  <Controller
                    name="attemptBariatrics1"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attemptBariatrics1"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attemptBariatrics1"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "attemptBariatrics1",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attemptBariatrics2">Attempt 2 Message</Label>
                  <Controller
                    name="attemptBariatrics2"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attemptBariatrics2"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attemptBariatrics2"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "attemptBariatrics2",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attemptBariatrics3">Attempt 3 Message</Label>
                  <Controller
                    name="attemptBariatrics3"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attemptBariatrics3"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attemptBariatrics3"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "attemptBariatrics3",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
              </>
            )}
            {orderType === orderTypeConstants.GFE && (
              <>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attemptGFE1">Attempt 1 Message</Label>
                  <Controller
                    name="attemptGFE1"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attemptGFE1"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attemptGFE1"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({ onBlur, field: "attemptGFE1" });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attemptGFE2">Attempt 2 Message</Label>
                  <Controller
                    name="attemptGFE2"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attemptGFE2"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attemptGFE2"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({ onBlur, field: "attemptGFE2" });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="w-full flex flex-column gap-2 mt-4">
                  <Label htmlFor="attemptGFE3">Attempt 3 Message</Label>
                  <Controller
                    name="attemptGFE3"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputTextarea
                        className="w-full"
                        id="attemptGFE3"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="attemptGFE3"
                        rows={3}
                        onBlur={() => {
                          handleOnBlurField({ onBlur, field: "attemptGFE3" });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
              </>
            )}
          </div>
          <div className="flex flex-column border-bottom-1 border-gray-200 pb-2">
            <span className="font-medium text-md mb-4">
              Email Alert Messages
            </span>
            {orderType === orderTypeConstants.PATIENT_RESPONSIBILITY && (
              <div className="formgrid grid">
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttempt1">
                    Email Template ID: Attempt 1
                  </Label>
                  <Controller
                    name="emailTemplateAttempt1"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttempt1"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttempt1"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttempt1",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttempt2">
                    Email Template ID: Attempt 2
                  </Label>
                  <Controller
                    name="emailTemplateAttempt2"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttempt2"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttempt2"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttempt2",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttempt3">
                    Email Template ID: Attempt 3
                  </Label>
                  <Controller
                    name="emailTemplateAttempt3"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttempt3"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttempt3"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttempt3",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
              </div>
            )}
            {orderType === orderTypeConstants.ED && (
              <div className="formgrid grid">
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttemptED1">
                    Email Template ID: Attempt 1
                  </Label>
                  <Controller
                    name="emailTemplateAttemptED1"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttemptED1"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttemptED1"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttemptED1",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttemptED2">
                    Email Template ID: Attempt 2
                  </Label>
                  <Controller
                    name="emailTemplateAttemptED2"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttemptED2"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttemptED2"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttemptED2",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttemptED3">
                    Email Template ID: Attempt 3
                  </Label>
                  <Controller
                    name="emailTemplateAttemptED3"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttemptED3"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttemptED3"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttemptED3",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
              </div>
            )}

            {orderType === orderTypeConstants.BUNDLED && (
              <div className="formgrid grid">
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttemptBundle1">
                    Email Template ID: Attempt 1
                  </Label>
                  <Controller
                    name="emailTemplateAttemptBundle1"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttemptBundle1"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttemptBundle1"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttemptBundle1",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttemptBundle2">
                    Email Template ID: Attempt 2
                  </Label>
                  <Controller
                    name="emailTemplateAttemptBundle2"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttemptBundle2"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttemptBundle2"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttemptBundle2",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttemptBundle3">
                    Email Template ID: Attempt 3
                  </Label>
                  <Controller
                    name="emailTemplateAttemptBundle3"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttemptBundle3"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttemptBundle3"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttemptBundle3",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
              </div>
            )}

            {/* {orderType === orderTypeConstants.BARIATRICS && (
              <div className="formgrid grid">
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttemptBariatrics1">
                    Email Template ID: Attempt 1
                  </Label>
                  <Controller
                    name="emailTemplateAttemptBariatrics1"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttemptBariatrics1"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttemptBariatrics1"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttemptBariatrics1",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttemptBariatrics2">
                    Email Template ID: Attempt 2
                  </Label>
                  <Controller
                    name="emailTemplateAttemptBariatrics2"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttemptBariatrics2"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttemptBariatrics2"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttemptBariatrics2",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttemptBariatrics3">
                    Email Template ID: Attempt 3
                  </Label>
                  <Controller
                    name="emailTemplateAttemptBariatrics3"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttemptBariatrics3"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttemptBariatrics3"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttemptBariatrics3",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
              </div>
            )} */}
            {orderType === orderTypeConstants.GFE && (
              <div className="formgrid grid">
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttemptGFE1">
                    Email Template ID: Attempt 1
                  </Label>
                  <Controller
                    name="emailTemplateAttemptGFE1"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttemptGFE1"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttemptGFE1"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttemptGFE1",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttemptGFE2">
                    Email Template ID: Attempt 2
                  </Label>
                  <Controller
                    name="emailTemplateAttemptGFE2"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttemptGFE2"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttemptGFE2"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttemptGFE2",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
                <div className="field md:col-4 col-12">
                  <Label htmlFor="emailTemplateAttemptGFE3">
                    Email Template ID: Attempt 3
                  </Label>
                  <Controller
                    name="emailTemplateAttemptGFE3"
                    control={control}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <InputText
                        className="w-full"
                        id="emailTemplateAttemptGFE3"
                        autoComplete="off"
                        value={value || ""}
                        placeholder="Enter your message here"
                        aria-labelledby="emailTemplateAttemptGFE3"
                        onBlur={() => {
                          handleOnBlurField({
                            onBlur,
                            field: "emailTemplateAttemptGFE3",
                          });
                        }}
                        onChange={onChange}
                      />
                    )}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
